import React, { Component } from 'react';
import { connect } from 'react-redux';
import { Form, Input, Select, Button } from 'antd';
import _ from 'lodash';
import { withOnFocus } from '../../../../../components/HOC';
import MultiSelect from '../../../../../components/MultiSelect';
import { branchesSelector } from '../../../../Organisation/scenes/Branch/BranchSelectors';
import { contactListSelector } from '../../../../Organisation/scenes/Contact/ContactSelectors';
import explanations from '../data/explanations.json';
import { loadingPlansSelector, currenciesSelector } from '../PlanSelectors';
import { defaultNewPlanCurrencyCodeSelector } from '../../../../Organisation/OrganisationSelectors';

const FormItem = Form.Item;
const { Option } = Select;

const PLAN_ACTIONS = Object.freeze({
  CREATE: 'CREATE',
  CLONE: 'CLONE',
  EDIT: 'EDIT',
  RENEW: 'ERNEW',
});

class PlanEdit extends Component {
  constructor(props) {
    super(props);
    this.InputWithOnFocus = withOnFocus(Input, props.onExplanationChange);
    this.SelectWithOnFocus = withOnFocus(Select, props.onExplanationChange);
    this.MultiSelectWithOnFocus = withOnFocus(MultiSelect, props.onExplanationChange);
  }

  onSubmit = (e) => {
    e.preventDefault();
    const { form, createPlan, clonePlan, updatePlan, renewPlan, close } = this.props;
    form.validateFields(async (err, values) => {
      if (err) return;
      const { plan, action } = this.props;
      try {
        switch (action) {
          case PLAN_ACTIONS.CREATE:
            await createPlan(values);
            break;
          case PLAN_ACTIONS.CLONE:
            await clonePlan({ ...values, planId: plan.planId, subscriptionKey: values.key });
            break;
          case PLAN_ACTIONS.EDIT:
            await updatePlan(plan.planId, values);
            break;
          case PLAN_ACTIONS.RENEW:
            await renewPlan(plan.planId, values);
            break;
          default:
            break;
        }
        close();
      } catch {
        // Error toasts are handled in PlanList (or caller) handlers
      }
    });
  };

  render() {
    const { InputWithOnFocus, SelectWithOnFocus, MultiSelectWithOnFocus } = this;
    const {
      form,
      plan = {},
      action,
      branches = [],
      contactList = [],
      currencies = [],
      loadingPlans,
      defaultNewPlanCurrencyCode,
    } = this.props;
    const { getFieldDecorator } = form;
    const currencyFromPlan = plan.currency ? _.find(currencies, { symbol: plan.currency }) : null;
    let initialCurrencyCode = 'AUD';
    if (currencyFromPlan) {
      initialCurrencyCode = currencyFromPlan.code;
    } else {
      const preferred = _.find(currencies, { code: defaultNewPlanCurrencyCode });
      const aud = _.find(currencies, { code: 'AUD' });
      if (preferred) initialCurrencyCode = preferred.code;
      else if (aud) initialCurrencyCode = aud.code;
      else if (currencies.length > 0) initialCurrencyCode = currencies[0].code;
    }

    return (
      <Form>
        {action !== PLAN_ACTIONS.RENEW && (
          <FormItem label="Plan Name">
            {getFieldDecorator('name', {
              initialValue: plan.name,
              rules: [{ required: true, message: 'Please input the name.' }],
            })(<InputWithOnFocus placeholder="Name" disabled={loadingPlans} explanation={explanations.name} />)}
          </FormItem>
        )}
        {action !== PLAN_ACTIONS.EDIT && action !== PLAN_ACTIONS.RENEW && (
          <FormItem label="Business Location">
            {getFieldDecorator('branchId', {
              rules: [{ required: true, message: 'Please select the business location.' }],
            })(
              <SelectWithOnFocus
                placeholder="Business Location"
                disabled={loadingPlans}
                explanation={explanations.branch}
              >
                {branches.map((obj) => (
                  <Option key={obj.name} value={obj.branchId}>
                    {obj.name}
                  </Option>
                ))}
              </SelectWithOnFocus>,
            )}
          </FormItem>
        )}
        {action !== PLAN_ACTIONS.EDIT && (
          <FormItem label="Subscription Key or Promo Code">
            {getFieldDecorator('key', {
              rules: [{ required: true, message: 'Please input a valid Subscription Key or Promo Code.' }],
            })(
              <InputWithOnFocus
                placeholder="Subscription Key or Promo Code"
                disabled={loadingPlans}
                explanation={explanations.subscriptionKey}
              />,
            )}
          </FormItem>
        )}
        {action !== PLAN_ACTIONS.RENEW && action !== PLAN_ACTIONS.CLONE && (
          <FormItem label="Currency">
            {getFieldDecorator('currency', {
              rules: [{ required: true, message: 'Please select currency.' }],
              initialValue: initialCurrencyCode,
            })(
              <SelectWithOnFocus placeholder="Currency" disabled={loadingPlans} explanation={explanations.currency}>
                {currencies.map((obj) => (
                  <Option key={obj.code} value={obj.code}>
                    {obj.name}
                  </Option>
                ))}
              </SelectWithOnFocus>,
            )}
          </FormItem>
        )}
        {action !== PLAN_ACTIONS.EDIT && action !== PLAN_ACTIONS.RENEW && (
          <FormItem label="Accountable Contacts">
            {getFieldDecorator('contacts')(
              <MultiSelectWithOnFocus
                placeholder="Add accountable members"
                disabled={loadingPlans}
                showSearch
                notFoundContent="Not Found"
                filterOption={(input, option) => option.props.children.toLowerCase().indexOf(input.toLowerCase()) >= 0}
                optionFilterProp="children"
                optionLabelProp="label"
                explanation={explanations.contact}
                dropdownMatchSelectWidth={false}
                dropdownStyle={{ minWidth: 320 }}
                dropdownMenuStyle={{ maxHeight: 360, overflowY: 'auto' }}
              >
                {contactList.map((contact) => (
                  <Option
                    key={contact.email}
                    value={contact.contactId}
                    label={`${contact.firstName} ${contact.lastName}`}
                  >
                    {contact.jobTitle
                      ? `${contact.firstName} ${contact.lastName} - ${contact.jobTitle}`
                      : `${contact.firstName} ${contact.lastName}`}
                  </Option>
                ))}
              </MultiSelectWithOnFocus>,
            )}
          </FormItem>
        )}
        <FormItem>
          <Button type="primary" block loading={loadingPlans} onClick={this.onSubmit}>
            {loadingPlans ? 'Saving' : 'Save'}
          </Button>
        </FormItem>
      </Form>
    );
  }
}

const mapStateToProps = (state) => ({
  branches: branchesSelector(state),
  contactList: contactListSelector(state),
  loadingPlans: loadingPlansSelector(state),
  currencies: currenciesSelector(state),
  defaultNewPlanCurrencyCode: defaultNewPlanCurrencyCodeSelector(state),
});

const mapDispatchToProps = {};

export default connect(mapStateToProps, mapDispatchToProps)(Form.create()(PlanEdit));

export { PLAN_ACTIONS };
